import React from "react"
import { Seo } from "../../components/seo"
import { graphql } from "gatsby"
import ResourceLayoutNew from "../../components/resourceLayoutNew"
const pageData = {
  type: "video",
  slug: "/videos/tc-tube-fuse-twentyfour",
  pagetitle: "video-tc-tube-fuse-twentyfour",
  title: "Transfer Cap for Tube Fusing to 7/16&quot; for welding C-Flex 24",
  description:
    "Video showcasing the Thomson Transfer Cap for Optimum Growth flasks using a C-Flex 24 tube fusing connection to a cell bag with inversion transfer in and out of the hood.",
  citation: "no citations",
  link: "https://player.vimeo.com/video/525707560",
  display: "video",
  productLine: "OG",
  product: ["931598-4", "931116"],
  related: ["931616-4", "788116"],
  relatednote: ["163", "100"],
}
export default function TcTubeFuseTwentyfour({ data }) {
  const { relatedApps, productData, productRelatedData } = data
  return (
    <ResourceLayoutNew
      relatedApps={relatedApps}
      productData={productData}
      productRelatedData={productRelatedData}
      pagedata={pageData}
    ></ResourceLayoutNew>
  )
}
export const Head = () => (
  <Seo
    title={pageData.pagetitle}
    ogtitle={pageData.title}
    description={pageData.description}
    type="article"
  />
)

export const query = graphql`
  {
    productData: allProductsJson(
      filter: { ref: { in: ["931598-4", "931116"] } }
    ) {
      edges {
        node {
          id
          ref
          title
          slug
          desc_main
          image
          partNumber {
            num
          }
        }
      }
    }

    productRelatedData: allProductsJson(
      filter: { ref: { in: ["931616-4", "788116"] } }
    ) {
      edges {
        node {
          id
          ref
          title
          slug
          desc_main
          image
          partNumber {
            num
          }
        }
      }
    }

    relatedApps: allTechlibraryJson(filter: { ref: { in: ["163", "100"] } }) {
      edges {
        node {
          id
          description
          title
          url
        }
      }
    }
  }
`
